module.exports = __webpack_public_path__ + "static/media/yiyuan4.550f0b59.png";